export const USER_INFORMATION_TEST_ID = 'USER_INFORMATION_TEST_ID';
export const REFRESH_BUTTON_TEST_ID = 'refresh-button';
export const TARGETINGS_COMPONENT_ID = 'targetings-component';
export const WARNING_ID = 'Warning-component';
